import type { TBotConfig } from '~entities/bot';

const apiBase = process.env.PUBLIC_API ?? 'https://api.ifriend.ai';

const DAY = 60 * 60 * 24;
export const getBot = async (botId: string, params?: RequestInit) => {
	const url = `${apiBase}/ai/configuration/bots/${botId}/`;

	const response = await fetch(url, {
		...params,
		next: {
			revalidate: DAY,
			...params?.next,
			tags: ['bot-any', `bot-${botId}`],
		},
	});
	if (!response.ok) {
		throw new Error(`Error fetching bot: ${response.status}`, {
			cause: response.status,
		});
	}
	return (await response.json()) as TBotConfig;
};
